import { useState } from "react";
import sirpiLogo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import nodeApi from "../lib/api";

function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await nodeApi.post("/auth/signin", { email, password });

      toast.success("Login Successful!");
      localStorage.setItem("user", JSON.stringify(res.data.user)); // Save user info
      localStorage.setItem("token", res.data.token); // Save token

      setTimeout(() => {
        navigate("/"); // ✅ Redirect to dashboard
      }, 100);
    } catch (err) {
      const errorMsg = err.response?.data?.msg || "Login failed";

      if (errorMsg === "User not found") {
        toast.error("User doesn't not exist. Please try again.");
        setTimeout(() => navigate("/signup"), 100);
      } else if (errorMsg === "Invalid password") {
        toast.error("Incorrect password. Please try again.");
      } else {
        toast.error(errorMsg);
      }
    }
  };

  return (
    <div className="d-flex vh-100 justify-content-center align-items-center bg-white">
      <div className="text-center" style={{ marginRight: "270px" }}>
        <h1 className="fw-bold display-5">
          ALERP<span className="fs-6">(v1.0.0)</span>
        </h1>
        <p className="mt-2 fw-bold">by</p>
        <img src={sirpiLogo} alt="Sirpi Logo" style={{ width: "100px" }} />
      </div>

      <div className="card shadow p-5" style={{ width: "400px" }}>
        <input
          id="email"
          type="email"
          className="form-control mb-4"
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          id="password"
          type="password"
          className="form-control mb-4"
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          className="btn btn-dark w-100 mb-5 fw-bold"
          onClick={handleLogin}
        >
          Login
        </button>
      </div>
    </div>
  );
}

export default SignIn;
